<small class="debug">{{me}}</small>
<!--<mat-toolbar color="primary">-->
<!--      <span class="fill-remaining-space">-->
<!--          <span *ngIf="selectionModel.selected.length < 2">-->
<!--            <mat-icon style="position: relative; top: 7px">dns</mat-icon>-->
<!--              {{'general.totalPlayersSelected' | transloco}}: {{selectionModel.selected.length}}-->
<!--          </span>-->
<!--      </span>-->
<!--    <span *ngIf="selectionModel.selected.length > 1">-->
<!--          <a mat-raised-button color="warn" style="position: relative; left: -14px" (click)="updateMultiple()">-->
<!--              <mat-icon>save</mat-icon>-->
<!--              {{'general.applyChangesTo' | transloco}} ({{selectionModel.selected.length}}) {{'general.players' | transloco}}-->
<!--         </a>-->
<!--      </span>-->
<!--</mat-toolbar>-->
@if (selectionModel.selected.length  === 0) {
  <mat-toolbar>
    <div>
      <mat-icon>info</mat-icon>
      <mat-label>{{'general.noItemSelected' | transloco}}</mat-label>
    </div>
  </mat-toolbar>
}
@else if (selectionModel.selected.length >= 1) {
  <div>
    <!-- <mat-expansion-panel [expanded]="true" (opened)="panelOpenState = true" (closed)="panelOpenState = false"> -->
    <form [formGroup]="formGroup" class="form">
      @if (selectionModel.selected.length > 0) {
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>tv</mat-icon>
                <span class="accordionIcons">{{'general.player' | transloco}}</span>
              </mat-panel-title>
              <mat-panel-description>
                <!-- {{panelOpenState ? 'open' : 'closed'}} -->
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div>
              <app-station-snapshot #appStationSnapshot (snapCompleted)="onSnapCompleted($event)" [enabled]="captureEnabled"></app-station-snapshot>
              <div [ngStyle]="{'opacity': commandSending ? 0.3: 1}" class="playerButtonsContainer">
                <a matTooltip="{{'general.start' | transloco}}" (click)="onCommand('start')">
                  <mat-icon>play_circle_filled</mat-icon>
                </a>
                @if (accessConfig?.del !== false) {
                  <a matTooltip="{{'general.stop' | transloco}}"
                    (click)="onCommand('stop')">
                    <mat-icon>pause_circle_filled</mat-icon>
                  </a>
                }
                @if (!dashboard && selectionModel.selected.length == 1 && experienceLevel > experienceLevelType.BEGINNER) {
                  <a [ngStyle]="{'color': pushNewContentColor ? '#4a89fe' : ''}" matTooltip="{{'general.pushNewContent' | transloco}}" (click)="onPushNewContent()">
                    <mat-icon>published_with_changes</mat-icon>
                  </a>
                }
                @if (accessConfig?.del !== false && selectionModel.selected.length == 1 && experienceLevel > experienceLevelType.BEGINNER) {
                  <a matTooltip="restart"
                    (click)="areYouSureRestart()">
                    <mat-icon>power_settings_new</mat-icon>
                  </a>
                }
                @if (selectionModel.selected.length == 1 || waitingSnap) {
                  <a matTooltip="{{'general.screenCapture' | transloco}}"
                    (click)="onCommand('snap')">
                    <mat-icon>add_a_photo</mat-icon>
                  </a>
                }
                @if (selectionModel.selected.length == 1 && experienceLevel > experienceLevelType.BEGINNER) {
                  <a matTooltip="{{'general.statistics' | transloco}}"
                    (click)="onCommand('stats')">
                    <mat-icon>timeline</mat-icon>
                  </a>
                }
                @if (selectionModel.selected.length == 1 && experienceLevel > experienceLevelType.BEGINNER) {
                  <a matTooltip="{{'general.checkVersion' | transloco}}"
                    (click)="onCommand('checkUpdates')">
                    <mat-icon>gpp_good</mat-icon>
                  </a>
                }
                @if (selectionModel.selected.length == 1 && experienceLevel > experienceLevelType.BEGINNER) {
                  <a matTooltip="{{'general.clearCaching' | transloco}}" (click)="onCommand('clearCaching')">
                    <mat-icon>bookmark_remove</mat-icon>
                  </a>
                }
                @if (!dashboard && selectionModel.selected.length == 1 && accessConfig?.del !== false && experienceLevel > experienceLevelType.BEGINNER) {
                  <a matTooltip="{{'general.disconnectPlayer' | transloco}}" (click)="onCommand('remove')">
                    <mat-icon>phonelink_erase</mat-icon>
                  </a>
                }
              </div>
              <div style="padding: 5px">
                <mat-divider></mat-divider>
                @if (!dashboard || selectedStation) {
                  <mat-form-field [ngStyle]="{'display': selectionModel.selected.length > 1 || dashboard ? 'none' : 'block'}" class="form-element" style="width: 100%">
                      <mat-label>{{'placeholder.playerName' | transloco}}</mat-label>
                      <input (keydown.enter)="stopEnter($event)" autocomplete="off" inputrestriction="basic1"
                             focusInOut (focusInOutChanged)="onFocusChanged($event)" matInput [formControlName]="'station_name'" type="text"
                             placeholder="">
                  </mat-form-field>
                }

                @if (!dashboard) {
                  <div class="cardInner">
                    <div [style.grid-area]="'AA'">
                      @if (selectionModel.selected.length > 0) {
                        <mat-form-field>
                          <mat-select formControlName="player_data_id" (selectionChange)="onSceneChange($event)">
                            @for (scene of this.scenesSimple; track scene) {
                              <mat-option [value]="scene.sceneId">
                                {{scene.name}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    </div>
                    <div style="position: relative; top: 10px" [style.grid-area]="'BB'">
                      <button mat-button (click)="openSceneAssignmentDialog()" matTooltip="{{'general.assignScene' | transloco}}">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                    <div style="position: relative; top: 10px" [style.grid-area]="'CC'">
                      <button mat-button style="position: relative; left: -10px" (click)="openSceneEditor()" matTooltip="{{'general.jumpToScene' | transloco}}">
                        <mat-icon>link</mat-icon>
                      </button>
                    </div>
                  </div>
                }
                @if (!dashboard || selectedStation) {
                  <div>
                    @if (experienceLevel > experienceLevelType.BEGINNER) {
                        <div fxLayout="row">
                          <mat-form-field [ngStyle]="{'display': dashboard ? 'none' : 'block'}" style="width: 180px;">
                            <mat-label>{{'placeholder.category' | transloco}}</mat-label>
                            <input inputrestriction="basic1" matInput placeholder="" value="{{formGroup.controls['tree_path'].value}}" readonly>
                          </mat-form-field>
                          <button style="position: relative; top: 10px" mat-flat-button [ngStyle]="{'display': dashboard ? 'none' : 'block'}" (click)="openCategoryTree()">
                            <mat-icon class="catFilter">folder_open</mat-icon>
                          </button>
                        </div>
                    }
                    @if (selectedStation && this.selectedStation.stat && experienceLevel > experienceLevelType.BEGINNER) {
                        <ul style="list-style-type: square">
                          <!-- legacy -->
                          @if (this.selectedStation.stat.$?.version !== '2') {
                            <div>
                              <li>{{'general.player' | transloco}}: Legacy</li>
                              <li>{{'general.watchDog' | transloco}}: {{this.selectedStation.stat.$.socket == '1' ? 'on' : 'off'}}</li>
                              <li>{{'general.system' | transloco}}: {{this.selectedStation.stat.$.os}}</li>
                              <li>{{'general.runtime' | transloco}}: {{this.selectedStation.stat.$.airVersion}}</li>
                              <li>{{'general.peakMemory' | transloco}}: {{this.selectedStation.stat.$.peakMemory}}</li>
                              <li>{{'general.totalMemory' | transloco}}: {{this.selectedStation.stat.$.totalMemory}}</li>
                              <li>{{'general.runningTime' | transloco}}: {{this.selectedStation.stat.$.runningTime}}</li>
                            </div>
                          }
                          <!-- pwa -->
                          @if (this.selectedStation.stat.$?.version === '2') {
                            <div>
                              <li>{{'general.player' | transloco}}: PWA</li>
                              <li>{{'general.status' | transloco}}: {{this.selectedStation.stat.$?.playing == '1' ? 'playing' : 'stopped'}}</li>
                              <li>wdConnected: {{this.selectedStation.stat.$?.wdConnected}}</li>
                              <li>wdExtension: {{this.selectedStation.stat.$?.wdExtension}}</li>
                              <li>wdNative: {{this.selectedStation.stat.$?.wdNative}}</li>
                              <li>platform: {{this.selectedStation.stat.$?.platform}}</li>
                              <li>libVersion: {{this.selectedStation.stat.$?.libVersion}}</li>
                            </div>
                          }
                          <!-- common -->
                          <li>{{'general.id' | transloco}}: {{this.selectedStation.stat.$.id}}</li>
                          <li>{{'general.version' | transloco}}: {{this.selectedStation.stat.$.appVersion}}</li>
                          <li>{{'general.updated' | transloco}}: {{this.selectedStation.stat.$.lastUpdate}}</li>
                          <li>{{'general.startTime' | transloco}}: {{this.selectedStation.stat.$.startTime}}</li>
                          <li>{{'general.connection' | transloco}}: {{this.selectedStation.stat?.$?.connection}}</li>
                          <li>{{'general.business' | transloco}}: {{this.selectedStation.stat?.$?.businessId ? this.selectedStation.stat?.$?.businessId : m_businessId}}</li>
                          @if (this.selectedStation.stat.$?.geoLocation?.ip) {
                            <li>IP geo: {{this.selectedStation.stat.$?.geoLocation?.ip}}</li>
                          }
                          @if (this.selectedStation.stat.$?.publicIp) {
                            <li>IP public: {{this.selectedStation.stat.$?.publicIp}}</li>
                          }
                          @if (this.selectedStation.stat.$?.localIp) {
                            <li>IP local: {{this.selectedStation.stat.$?.localIp}}</li>
                          }
                          <li>{{'general.source' | transloco}}: {{selectedStationSource | StringJSV2Pipe:stringJSPipeArgs}}</li>
                          @if (debugMode) {
                            <li>long id: {{this.selectedStation.stat.$.station_business_id}}</li>
                          }
                          <li>geo lat: {{this?.selectedStation?.geo?.lat}}</li>
                          <li>geo lon: {{this?.selectedStation?.geo?.lon}}</li>
                          <li>geo city: {{this?.selectedStation?.geo?.city}}</li>
                        </ul>
                      }
                    </div>
                  }
                </div>
              </div>
          </mat-expansion-panel>
          @if (experienceLevel > experienceLevelType.BEGINNER) {
                    <mat-expansion-panel [expanded]="false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <mat-icon>add_alert</mat-icon>
                          <span class="accordionIcons">{{'general.monitor' | transloco}}</span>
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div>
                        <mat-checkbox formControlName="send_notification">{{'placeholder.sendNotification' | transloco}}</mat-checkbox>
                      </div>
                      <!--                <div>-->
                      <!--                    <mat-checkbox (change)="onTrackingChanged()" formControlName="tracking">{{'placeholder.trackOverTime' | transloco}}</mat-checkbox>-->
                    <!--                </div>-->
                  </mat-expansion-panel>
                  @if (debugMode && !dashboard && this.selectedStation) {
                    <mat-expansion-panel [expanded]="false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <mat-icon>flash_on</mat-icon>
                          <span class="accordionIcons">{{'general.log' | transloco}}</span>
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div fxLayout="column">
                        <mat-checkbox formControlName="log_enabled">{{'general.logEnabled' | transloco}}</mat-checkbox>
                      </div>
                      <div fxLayout="column" style="padding: 10px">
                        <mat-form-field class="custom-select full-width" [formGroup]="formGroup">
                          <mat-label>{{'general.logPriority' | transloco}}</mat-label>
                          <mat-select formControlName="log_priority" style="width: 100%" required class="form-control">
                            @for (priority of priorityLevels; track priority) {
                              <mat-option [value]="priority">
                                {{priority.name}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <!--                <div *ngIf="isFullFeatures" fxLayout="column" style="padding: 10px">-->
                      <!--                    <mat-form-field class="custom-select full-width" [formGroup]="formGroup">-->
                      <!--                        <mat-label>{{'general.tags' | transloco}}</mat-label>-->
                      <!--                        <input formControlName="log_tags" type="text" matInput placeholder="">-->
                    <!--                    </mat-form-field>-->
                  <!--                </div>-->
                  @if (isFullFeatures) {
                    <div fxLayout="column" style="padding: 10px">
                      <mat-form-field class="custom-select full-width" [formGroup]="formGroup">
                        <mat-label>{{'general.tags' | transloco}}</mat-label>
                        <input formControlName="log_tags" type="text" matInput placeholder="">
                      </mat-form-field>
                    </div>
                  }
                  @if (isFullFeatures) {
                    <div fxLayout="column" style="padding: 10px">
                      <div fxLayout="column" style="height: 200px; overflow-y: scroll">
                        @for (item of logTagsDB; track item) {
                          <div>
                            <mat-checkbox (change)="onTagChanged(item)" [value]="item" [checked]="item.value">{{item.name}}</mat-checkbox>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </mat-expansion-panel>
              }
              @if (!dashboard && this.selectedStation) {
                <mat-expansion-panel [expanded]="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon>flash_on</mat-icon>
                      <span class="accordionIcons">{{'general.performance' | transloco}}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div fxLayout="column">
                    <mat-form-field>
                      <mat-label>{{'general.frameRate' | transloco}}</mat-label>
                      <input inputrestriction="basic1" matInput [formControlName]="'frame_rate'" type="number" placeholder="">
                    </mat-form-field>
                    <mat-form-field>
                      <mat-select placeholder="{{'placeholder.quality' | transloco}}" formControlName="quality">
                        @for (item of [{name: 'high', value: 2}, {name: 'medium', value: 1}, {name: 'low', value: 0}]; track item) {
                          <mat-option [value]="item.value">{{item.name}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-checkbox formControlName="transition_enabled">{{'placeholder.transitionEnabled' | transloco}}</mat-checkbox>
                  </div>
                </mat-expansion-panel>
              }
              @if (!dashboard && this.selectedStation) {
                <mat-expansion-panel [expanded]="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon>history</mat-icon>
                      <span class="accordionIcons">{{'general.reboots' | transloco}}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                      <!-- {{panelOpenState ? 'open' : 'closed'}} -->
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <span class="accordionIcons">{{'general.rebootMemoryConditions' | transloco}}</span>
                  <br/>
                  <mat-radio-group formControlName="reboot_exceed_mem_action">
                    <br/>
                    <mat-checkbox formControlName="reboot_exceed_mem_enabled">{{'placeholder.enabled' | transloco}}</mat-checkbox>
                    @for (item of [{name: 'off', value: 0}, {name: 'soft', value: 1}, {name: 'hard', value: 2}]; track item) {
                      <mat-radio-button [ngClass]="{opacityLow: modeRebootExceedMemEnabled == false}" class="d-flex" style="padding-top: 10px;" fxLayout="column"
                        [value]="item.value">
                        {{item.name}}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                  <br/>
                  <hr/>
                  <mat-form-field>
                    <mat-label>{{'general.rebootMemThreshold' | transloco}}</mat-label>
                    <input inputrestriction="basic1" [ngClass]="{opacityLow: modeRebootExceedMemEnabled == false}" matInput [formControlName]="'reboot_exceed_mem_value'" type="number" step="0.1"
                      placeholder="">
                    </mat-form-field>
                    <br/>
                    <hr/>
                    <span class="accordionIcons">{{'general.dailyRestarts' | transloco}}</span>
                    <br/>
                    <mat-radio-group formControlName="reboot_time_action">
                      <br/>
                      <mat-checkbox formControlName="reboot_time_enabled">{{'placeholder.enabled' | transloco}}</mat-checkbox>
                      @for (item of [{name: 'off', value: 0}, {name: 'soft', value: 1}, {name: 'hard', value: 2}]; track item) {
                        <mat-radio-button [ngClass]="{opacityLow: modeRebootTimeEnabled == false}" class="d-flex" style="padding-top: 10px" fxLayout="column"
                          [value]="item.value">
                          {{item.name}}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                    <br/>
                    <mat-form-field>
                      <mat-label>{{'general.rebootTime' | transloco}}</mat-label>
                      <input inputrestriction="basic1" [ngClass]="{opacityLow: modeRebootTimeEnabled == false}" matInput formControlName="reboot_time_value" type="time" step="1"
                        placeholder="">
                      </mat-form-field>
                      <hr/>
                      <span class="accordionIcons">{{'general.errorReboot' | transloco}}</span>
                      <br/>
                      <mat-radio-group formControlName="reboot_error_action">
                        <br/>
                        <mat-checkbox formControlName="reboot_error_enabled">{{'placeholder.enabled' | transloco}}</mat-checkbox>
                        @for (item of [{name: 'off', value: 0}, {name: 'soft', value: 1}, {name: 'hard', value: 2}]; track item) {
                          <mat-radio-button [ngClass]="{opacityLow: modeRebootErrorEnabled == false}" style="padding-top: 10px" class="d-flex" fxLayout="column"
                            [value]="item.value">
                            {{item.name}}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                      <br/>
                    </mat-expansion-panel>
                  }
                  @if (!dashboard && this.selectedStation) {
                    <mat-expansion-panel [expanded]="false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <mat-icon>power_settings_new</mat-icon>
                          <span class="accordionIcons">{{'general.power' | transloco}}</span>
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div>
                        <span class="accordionIcons">{{'general.powerSavings' | transloco}}</span>
                        <mat-radio-group formControlName="power_mode">
                          <br/>
                          @for (item of [{name: 'off', value: 0}, {name: 'monitor', value: 1}, {name: 'station [BIOS ON]', value: 2}]; track item) {
                            <mat-radio-button class="d-flex" style="padding-top: 10px" fxLayout="column"
                              [value]="item.value">
                              {{item.name}}
                            </mat-radio-button>
                          }
                        </mat-radio-group>
                        <div class="cardInner2" style="position: relative; left: -15px">
                          <div [style.grid-area]="'AA1'">
                          </div>
                          <div [style.grid-area]="'BB1'">
                            {{'general.turnOn' | transloco}}
                          </div>
                          <div [style.grid-area]="'CC1'">
                            {{'general.turnOff' | transloco}}
                          </div>
                          <div class="smallDay" [style.grid-area]="'AA2'">
                            {{'general.sunday' | transloco}}
                          </div>
                          <div [style.grid-area]="'BB2'">
                            <input inputrestriction="basic1" [ngClass]="{opacityLow: modeBiosEnabled == '2'}" matInput formControlName="power_on_day1" type="time" class="without_ampm"/>
                          </div>
                          <div [style.grid-area]="'CC2'">
                            <input inputrestriction="basic1" matInput formControlName="power_off_day1" type="time" class="without_ampm"/>
                          </div>
                          <div class="smallDay" [style.grid-area]="'AA3'">
                            {{'general.monday' | transloco}}
                          </div>
                          <div [style.grid-area]="'BB3'">
                            <input inputrestriction="basic1" [ngClass]="{opacityLow: modeBiosEnabled == '2'}" matInput formControlName="power_on_day2" type="time" class="without_ampm"/>
                          </div>
                          <div [style.grid-area]="'CC3'">
                            <input inputrestriction="basic1" matInput formControlName="power_off_day2" type="time" class="without_ampm"/>
                          </div>
                          <div class="smallDay" [style.grid-area]="'AA4'">
                            {{'general.tuesday' | transloco}}
                          </div>
                          <div [style.grid-area]="'BB4'">
                            <input inputrestriction="basic1" [ngClass]="{opacityLow: modeBiosEnabled == '2'}" matInput formControlName="power_on_day3" type="time" class="without_ampm"/>
                          </div>
                          <div [style.grid-area]="'CC4'">
                            <input inputrestriction="basic1" matInput formControlName="power_off_day3" type="time" class="without_ampm"/>
                          </div>
                          <div class="smallDay" [style.grid-area]="'AA5'">
                            {{'general.wednesday' | transloco}}
                          </div>
                          <div [style.grid-area]="'BB5'">
                            <input inputrestriction="basic1" [ngClass]="{opacityLow: modeBiosEnabled == '2'}" matInput formControlName="power_on_day4" type="time" class="without_ampm"/>
                          </div>
                          <div [style.grid-area]="'CC5'">
                            <input inputrestriction="basic1" matInput formControlName="power_off_day4" type="time" class="without_ampm"/>
                          </div>
                          <div class="smallDay" [style.grid-area]="'AA6'">
                            {{'general.thursday' | transloco}}
                          </div>
                          <div [style.grid-area]="'BB6'">
                            <input inputrestriction="basic1" [ngClass]="{opacityLow: modeBiosEnabled == '2'}" matInput formControlName="power_on_day5" type="time" class="without_ampm"/>
                          </div>
                          <div [style.grid-area]="'CC6'">
                            <input inputrestriction="basic1" matInput formControlName="power_off_day5" type="time" class="without_ampm"/>
                          </div>
                          <div class="smallDay" [style.grid-area]="'AA7'">
                            {{'general.friday' | transloco}}
                          </div>
                          <div [style.grid-area]="'BB7'">
                            <input inputrestriction="basic1" [ngClass]="{opacityLow: modeBiosEnabled == '2'}" matInput formControlName="power_on_day6" type="time" class="without_ampm"/>
                          </div>
                          <div [style.grid-area]="'CC7'">
                            <input inputrestriction="basic1" matInput formControlName="power_off_day6" type="time" class="without_ampm"/>
                          </div>
                          <div class="smallDay" [style.grid-area]="'AA8'">
                            {{'general.saturday' | transloco}}
                          </div>
                          <div [style.grid-area]="'BB8'">
                            <input inputrestriction="basic1" [ngClass]="{opacityLow: modeBiosEnabled == '2'}" matInput formControlName="power_on_day7" type="time" class="without_ampm"/>
                          </div>
                          <div [style.grid-area]="'CC8'">
                            <input inputrestriction="basic1" matInput formControlName="power_off_day7" type="time" class="without_ampm"/>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  }
                  <!--      <mat-expansion-panel *ngIf="!dashboard && accessStationProperties.lanServer === '1'" [expanded]="false">-->
                  @if (!dashboard && this.selectedStation) {
                    <mat-expansion-panel [expanded]="false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <mat-icon>perm_data_setting</mat-icon>
                          <span class="accordionIcons">{{'general.server' | transloco}}</span>
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div>
                        <hr/>
                        <mat-checkbox formControlName="lan_server_enabled">{{'general.lanServerEnabled' | transloco}}</mat-checkbox>
                        <mat-form-field>
                          <mat-label>{{'general.lanServerIp' | transloco}}</mat-label>
                          <input inputrestriction="basic1" [ngClass]="{opacityLow: lanServerEnabled == false}" matInput [formControlName]="'lan_server_ip'" type="number" step="0.1"
                            placeholder="">
                          </mat-form-field>
                          <mat-form-field>
                            <mat-label>{{'general.lanServerPort' | transloco}}</mat-label>
                            <input inputrestriction="basic1" [ngClass]="{opacityLow: lanServerEnabled == false}" matInput [formControlName]="'lan_server_port'" type="number" step="1"
                              placeholder="">
                            </mat-form-field>
                          </div>
                        </mat-expansion-panel>
                      }
                  <!--            <mat-expansion-panel *ngIf="!dashboard" [expanded]="false">-->
                  <!--                <mat-expansion-panel-header>-->
                  <!--                    <mat-panel-title>-->
                  <!--                        <mat-icon>camera_enhance</mat-icon>-->
                  <!--                        <span class="accordionIcons">{{'general.camera' | transloco}}</span>-->
                <!--                    </mat-panel-title>-->
                <!--                    <mat-panel-description>-->
              <!--                    </mat-panel-description>-->
            <!--                </mat-expansion-panel-header>-->
            <!--                <div>-->
            <!--                    CCC-->
          <!--                </div>-->
        <!--            </mat-expansion-panel>-->
        }
  </mat-accordion>
}
</form>
</div>
}


<ng-template let-modal #rebootDialog>
  <small class="debug">{{me}}</small>
  <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <mat-icon class="moveMatIcon">exit_to_app</mat-icon>
    <mat-label>{{'general.rebootPlayer' | transloco}}</mat-label>
    <div class="dlg-drag-handle" cdkDragHandle>
      <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
        <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
        <path d="M0 0h24v24H0z" fill="none"></path>
      </svg>
    </div>
  </h1>
  <div mat-dialog-content>
    <br/>
    <br/>
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-radio-group aria-label="Select an option" [(ngModel)]="rebootModal">
        <mat-radio-button value="1">{{'general.softRestart' | transloco}}</mat-radio-button>
        <mat-radio-button value="2">{{'general.hardRestart' | transloco}}</mat-radio-button>
      </mat-radio-group>
      <br/>
    </div>
    <br/>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button (click)="onRebootHardOrSoft(); rebootDiag.close()" color="warn" mat-raised-button>
        <mat-icon>power_settings_new</mat-icon>
        {{'general.restart' | transloco}}
      </button>
      <button style="margin-left: 10px" (click)="rebootDiag.close()" mat-raised-button>
        <mat-icon>close</mat-icon>
        {{'general.cancel' | transloco}}
      </button>
      <br/>
    </div>
    <br/>
    <br/>
    <br/>
    <a class="mediaDroidOrder" (click)="download('mediadroid')" mat-button>
      <mat-icon>star</mat-icon>
      For best performance, improved Watchdog, support for hard reboot, get mediaDROID+
    </a>
  </div>
</ng-template>
